import { useTheme } from '../../../../redux/hooks/useTheme';
import React from 'react';
import { useNavigate } from 'react-router-dom';
type Props={
title:string;
subTitle:string;
setShowLimitPopup:React.Dispatch<React.SetStateAction<boolean>>;
}
export const LimitExceedPopup:React.FC<Props> =({title,subTitle,setShowLimitPopup})=>{
    const { theme } = useTheme();
    const navigate = useNavigate();

    const upgradePlan =()=>{
        navigate('/pricing');
        setShowLimitPopup(false);
    }
  return( <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50">
    <div
      style={{ backgroundColor: theme.primaryBackground, color: theme.viewMoreHeading }}
      className="p-6 rounded-xl shadow-lg max-w-md w-full mx-4"
    >
      <div className="text-center mb-5">
        <div className="flex justify-center mb-4">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z" stroke="#FB5F65" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12 8V13" stroke="#FB5F65" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.9946 16H12.0036" stroke="#FB5F65" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <h2 className="text-xl font-semibold mb-2" style={{ color: theme.mainHeadingOne }}>
          {title}
        </h2>
        <p className="text-sm">
          {subTitle}
        </p>
      </div>

      <div className="flex justify-center gap-3 mt-6">
        <button
          onClick={()=>{
            setShowLimitPopup(false)
          }}
          style={{ backgroundColor: theme.viewPlanBorder, color: theme.viewMoreHeading }}
          className="px-4 py-2 rounded-lg transition hover:opacity-90 min-w-[100px]"
        >
          Cancel
        </button>
        <button
          onClick={upgradePlan}
          className="px-5 py-2 rounded-lg text-white font-medium transition hover:opacity-90 min-w-[100px]"
          style={{ background: 'linear-gradient(95.48deg, #FF3AB6 0%, #FB5F65 100%)' }}
        >
          Upgrade Plan
        </button>
      </div>
    </div>
  </div>)
}
